import { Button } from 'aimo-ui';
import useRetryChargingPaymentMutation from 'hooks/useRetryChargingPaymentMutation';
import useSelectedPaymentMethod from 'hooks/useSelectedPaymentMethod';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRetryPaymentStore } from 'stores/retryPaymentStore';
import { ChargingPaymentState } from 'types/generatedSchemaTypes';

type RetryChargingPaymentProps = {
  token: string;
  chargingSessionId: string | undefined;
  loading: boolean;
  paymentState: ChargingPaymentState;
};

const RetryChargingPaymentButton: React.FC<RetryChargingPaymentProps> = ({
  token,
  chargingSessionId,
  loading,
  paymentState,
}) => {
  const { t } = useTranslation();
  const paymentCard = useSelectedPaymentMethod();
  const storeStatus = useRetryPaymentStore((s) =>
    s.getChargingSessionStatus(chargingSessionId as string, paymentState)
  );
  const isRetrying = storeStatus === 'Retrying' || storeStatus === 'Pending';
  const canRetry = storeStatus === 'Failed';
  const { retryChargingPayment, retryPaymentLoading } =
    useRetryChargingPaymentMutation({
      chargingSessionId,
    });

  const handleRetry = async () => {
    await retryChargingPayment({
      variables: { input: { cardId: paymentCard?.cardId, token } },
    });
  };

  return (
    <Button
      text={t('button.retryPayment')}
      size="l"
      testID="close"
      buttonType="primary"
      onPress={handleRetry}
      loading={retryPaymentLoading || loading || isRetrying}
      disabled={!canRetry || retryPaymentLoading || loading}
    />
  );
};

export default RetryChargingPaymentButton;
